<app-header [label]="page_name"></app-header>

<app-ag-grid-list
  [list]="items"
  [colDefs]="columns"
  [bulk_delete]="false"
  [show_checkboxes]="false"
  [itemName]="page_name"
  (fetch_new_list)="get_list($event)"
  main_description="No face mismatch logs found"
  description="No records where face verification failed">
</app-ag-grid-list>
